import request from '../../request';

export default {
  state: {
    formValid: undefined,
    formSaved: undefined,
    form: [],
  },
  mutations: {
    setImageForm(state, imageRes) {
      const images = imageRes;
      const imageForm = [];

      images.forEach((image) => {
        imageForm.push(
          {
            thumbnail: image.thumbnail_path,
            id: {
              name: 'image_id',
              value: image.id,
            },
            namePt: {
              name: 'name:pt',
              label: 'Title Pt',
              value: image.locale.pt.name,
              icon: '',
              untouched: true,
              errors: [],
            },
            nameEn: {
              name: 'name:en',
              label: 'Title En',
              value: image.locale.en.name,
              icon: '',
              untouched: true,
              errors: [],
            },
          });
      });
      Object.assign(state, { form: imageForm });
      if (typeof window.Materialize !== 'undefined') {
        setTimeout(() => {
          window.Materialize.updateTextFields();
        }, 500);
      }
    },
    updateImageLabels(state, payload) {
      Object.assign(state.form[payload.index][payload.language], { value: payload.label });
    },
  },
  actions: {
    removeActivityImage(context, payload) {
      request.make({
        type: 'DELETE',
        url: `${process.env.API_URL}activity_image/${payload.value}`,
      }, (err, res) => {
        if (res.status === 204) {
          context.dispatch('removeActivityImage', payload.value);
        }
      });
    },
    saveImageLabels(context, index) {
      const data = {};
      data.image_id = context.state.form[index].id.value;
      data.pt = {};
      data.en = {};
      data.pt.name = context.state.form[index].namePt.value;
      data.en.name = context.state.form[index].nameEn.value;

      request.make({
        type: 'PATCH',
        url: `${process.env.API_URL}activity_image`,
        data,
      }, () => true);
    },
    saveAllImageLabels(context) {
      context.state.form.forEach((image) => {
        const data = {};
        data.image_id = image.id.value;
        data.pt = {};
        data.en = {};
        data.pt.name = image.namePt.value;
        data.en.name = image.nameEn.value;

        request.make({
          type: 'PATCH',
          url: `${process.env.API_URL}activity_image`,
          data,
        });
      });
    },
  },
  getters: {

  },
};




// WEBPACK FOOTER //
// ./src/store/promoter/activityImage.js